import React from 'react';

export default function PageLoader({ text = 'Loading…' }) {
  return (
    <div className="page-loader" role="status" aria-live="polite">
      <div className="loader-spinner" />
      <div className="loader-text">{text}</div>
    </div>
  );
}
